module.exports = __webpack_public_path__ + "static/img/lobby.495e8de2.png";